import MuiStack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const StyledStack = styled(MuiStack)({}) as typeof MuiStack;
